export const Bio = {
    name: "Ankit Anand",
    roles: [
      "Full Stack Developer"
    ],
    description:
      "Results-oriented Software Developer with expertise in full-stack development, CRM systems, and E-commerce platforms. Proficient in Python, Java, C#, .NET, SQL, Vue.js, React.js, and Sitecore. Experienced in optimizing application performance, automating workflows, and delivering data-driven solutions that enhance user engagement and business outcomes.",
    github: "https://github.com/incognito0007",
    resume:
      "https://docs.google.com/document/d/1APBLgmhSWzLfIRz9P8s-Ic-N8o4T3Nn1VKOAB1ndmJc/edit?usp=sharing",
    linkedin: "https://www.linkedin.com/in/ankit-anand-820264206/",
    twitter: "https://x.com/ank1t_anand",
  };
  
  export const experiences = [
    {
      id: 0,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBzTaGxhdKG0vLrjQ3fUs4GZwAs0s7GgdvUA&s",
      role: "Junior Software Developer",
      company: "Jet2 Travel and Technology",
      date: "July 2024 - Present",
      desc: "I collaborated with the E-commerce team to enhance the holiday and flight booking platforms, focusing on high performance and scalability. I developed and maintained core application features using .NET and C#, which improved platform stability and minimized downtime. I also integrated and customized Sitecore CMS to deliver personalized user experiences, leading to greater customer engagement. On the frontend, I implemented features with Vue.js to improve UI responsiveness and boost booking funnel conversion rates. Additionally, I optimized backend services for more efficient data handling and transaction processing, reducing the average booking response time. Working in an Agile/Scrum environment, I partnered closely with designers, QA engineers, and product owners to ensure timely delivery of high-quality releases."
    },
    {
      id: 1,
      img: "https://marketdisc.com/assets/images/logo.gif",
      role: "Software Developer",
      company: "Market Disc Media",
      date: "Apr 2024 - May 2024",
      desc: "I designed and implemented a custom CRM platform that significantly improved customer relationship management and provided better visibility into team performance. On the backend, I developed services using Python and Node.js, integrating them with SQL databases to ensure 99.9% data accuracy and scalability. To streamline operations, I introduced automation features that reduced manual processes by 30%, which greatly enhanced efficiency. I also built interactive dashboards and analytics modules that allowed leadership to track key performance indicators and customer engagement trends, improving decision-making speed by 25%. On the frontend, I engineered a responsive UI/UX with HTML and CSS, which increased adoption among internal teams by 40%. Throughout the process, I collaborated closely with stakeholders to ensure the CRM aligned with business objectives, ultimately contributing to a 20% increase in overall team productivity.",
    },
    {
      id: 2,
      img: "https://seeklogo.com/images/P/persistent-systems-logo-6DDF70EF79-seeklogo.com.png",
      role: "Summer Intern",
      company: "Persistent Martian",
      date: "June 2023 - Aug 2023",
      desc: "Acquired comprehensive understanding of Database Management Systems (DBMS), Enhanced Python programming skills to a developer-level through practical applications",
    },
  ];
  
  export const projects = [
    {
      id: 0,
      title: "Insightful HR Analytics: Unveiling Employee Turnover",
      date: "Feb 2024 - March 2024",
      description:
        "Collected and processed a comprehensive employee dataset, including age, salary, tenure, job roles, and more. Conducted thorough data preprocessing and analysis to identify key factors influencing employee turnover and job satisfaction. Developed an interactive Power BI dashboard showcasing insights on attrition rates, satisfaction levels, and workforce trends to support data-driven HR decisions.",
      image:
        "https://images.shiksha.com/mediadata/shikshaOnline/mailers/2021/naukri-learning/oct/28oct/What-is-Data-Analysis.jpg",
      tags: ["Power BI", "Excel", "Data Analysis",],
      category: "Data Analysis",
      github: "https://github.com/incognito0007/HR-ANALYTICS",
      webapp: ""
    },
    {
      id: 1,
      title: "Tunes & Trends: SQL Music Analysis",
      date: "Jan 2024 - Feb 2024",
      description:
        "Conducted comprehensive SQL analysis on a music database system to identify the most popular albums and genres favored by audiences. Extracted and analyzed data to uncover key trends and insights within the music industry, including audience preferences and listening habits.",
      image:
        "https://www.piano-composer-teacher-london.co.uk/wp-content/uploads/2021/06/255d68_486f8704bb7f4ffea1b2fa218664acf9mv21.webp",
      tags: [
        "SQL",
        "MS Excel",
        "Data Analysis",
      ],
      category: "SQL Data Analysis",
      github: "https://github.com/incognito0007/SQL-Project-Music-Database-Analysis",
      webapp: ""
    },
    {
      id: 2,
      title: "Real Time Railway Safety Monitoring",
      date: "Sep 2023 - Dec 2023",
      description:
        "Conducted in-depth analysis of railway accidents data from India, USA, and UK to derive significant insights into the causes and patterns of accidents. Utilized machine learning techniques, including decision tree algorithms, to identify key factors contributing to accidents and assess their impact on different demographic groups such as age and gender. Generated actionable insights to understand the root causes of accidents and proposed future scope for accident prevention strategies, aiming to mitigate casualties and enhance railway safety.",
      image:
        "https://lirp.cdn-website.com/81aad348/dms3rep/multi/opt/railway-safety_icon_2b-640w.png",
      tags: ["Python", "Keras", "TensorFlow", "Machine Learning", "Jupyter", "numpy", "Pandas"],
      category: "machine learning",
      github: "https://github.com/incognito0007/Railway-safety-using-ML",
      webapp: ""
    },
    {
      id: 3,
      title: "Neural Nodule Navigator",
      date: "March 2023 - June 2023",
      description:
        "Developed a cutting-edge predictive model leveraging Convolutional Neural Network (CNN) architecture to facilitate rapid and accurate diagnosis of brain tumors. Analyzed a vast dataset comprising scanned MRI images of the human brain to autonomously detect crucial elements, thereby eliminating the necessity for human oversight. Utilized machine learning libraries such as Keras and TensorFlow to implement the CNN model, ensuring efficient processing and optimal performance.",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRohgqY3LHZagrtOAx4A57tcbdknAEcqpFgGA&s",
      tags: ["Keras", "tensorflow", "Convolutional Neural Network (CNN)", "matplotlin", "pandas"],
      category: "Predictive Model using CNN",
      github: "https://github.com/incognito0007/brain-tumor-detection-project",
      webapp: ""
    },
  ];

  export const skills = [
    {
      title: "Software Development",
      skills: [
        {
          name: "C#",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/csharp/csharp-original.svg",
        },
        {
          name: ".NET",
          image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/dot-net/dot-net-original.svg",
        },
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "HTML, CSS, JS",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "SQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "React Js",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
        {
          name: "Angular",
          image: "https://angular.io/assets/images/logos/angular/angular.svg",
        },
      ],
    },
    {
      title: "Tools & Technologies",
      skills: [
        {
          name: "Sitecore",
          image: "https://img.icons8.com/?size=512&id=63257&format=png",
        },
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "PostgreSQL",
          image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        },
        {
          name: "PowerBI",
          image:
            "https://powerbi.microsoft.com/pictures/shared/social/social-default-image.png",
        },
        {
          name: "MS EXCEL",
          image:
            "https://w7.pngwing.com/pngs/637/554/png-transparent-microsoft-spreadsheet-macos-microsoft-office-2016-microsoft-excel-microsoft-word-16-rectangle-microsoft-office-microsoft.png",
        },
        {
          name: "Azure DevOps",
          image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/azure/azure-original.svg",
        }
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Postman",
          image: "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
        },
      ],
    },
  ];